module.exports = __webpack_public_path__ + "img/select.b63d838f.svg";